import { REQUIRED } from "./validation-rules"

export default class FormValidationRules {
  static required(val) {
    let match = REQUIRED(val)
    if(match === true) return true
    return false
  }
}